import { IContent } from "../../models/allPayments.model";
import { ITransactionState } from "./state.interface";

export const initialTransactionState: ITransactionState = {
    payment: null,
    laodingPayment: true,
    paymentDetails: {} as IContent,
    loading: false,
    downloaded: '',
    error: '',
    filterPersistence: null
};